import styled from 'styled-components';

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
`;

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const ContactInfoHeader = styled.h1`
  font-family: ${props => props.theme.fonts.circular} !important;
  font-size: ${props => props.theme.fontSizes.displayXL} !important;
  font-weight: ${props => props.theme.fontWeights.bold} !important;
  letter-spacing: ${props => props.theme.letterSpacings.one} !important;
  color: ${props => props.theme.colors.capsuleBlue50} !important;

  ${props => props.theme.mediaQueries.smallDown} {
    font-size: ${props => props.theme.fontSizes.headerOne} !important;
  }

  ${props => props.theme.mediaQueries.large} {
    font-size: ${props => props.theme.fontSizes.displayXXL} !important;
  }
`;

export const ButtonSection = styled.div`
  margin-top: ${props => props.theme.space.none} !important;
`;
